import { ready } from '~/core'
const SCREEN_WIDTH_LARGE = 992
const OFFSET_PADDING = 24

ready('spotlight', '.spotlight--tabbed', (spotlight) => {
  const tabs = [...spotlight.querySelectorAll('button.spotlight-tab')]
  const inners = [...spotlight.querySelectorAll('.spotlight-inner')]

  const setActive = (element) => {
    element.classList.add('active')
  }

  const clearAllActive = () => {
    tabs.forEach((tab) => tab.classList.remove('active'))
    inners.forEach((inner) => inner.classList.remove('active'))
  }

  const scrollToElement = (element) => {
    const topOffset = element.getBoundingClientRect().top + (window.scrollY - OFFSET_PADDING)

    window.scrollTo({
      top: topOffset,
      behavior: 'smooth',
    })
  }

  const handleClick = (tab, isMobileOrTabletScreen) => {
    const targetInner = spotlight.querySelector(`.spotlight-inner[data-tab="${tab.getAttribute('data-tab')}"]`)

    clearAllActive()
    setActive(tab)
    setActive(targetInner)

    if (isMobileOrTabletScreen) scrollToElement(tab)
  }

  const init = (isResizing = false) => {
    const isMobileOrTabletScreen = window.innerWidth <= SCREEN_WIDTH_LARGE

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => handleClick(tab, isMobileOrTabletScreen))
    })

    if (isResizing) return

    // set first tab & inner as active
    setActive(tabs[0])
    setActive(inners[0])
  }

  init()

  window.addEventListener('resize', () => init(true))

  window.addEventListener('beforeunload', () => {
    window.removeEventListener('resize', () => init(true))
  })
})
